import { Moment } from 'moment'
import { getLiveboardSettingRef } from '../Liveboard.service'
import prodConfig from './../config/prod-config.json'
import { toJSON } from '@/utils/common'
import { INSPECTION_TYPE_KEY } from '@/constant/common'

export const liveboardDateUtil = {
  getDisplay: (date: Moment) => date.format('DD MMM YYYY'),
}

export const getTenantConfig = async (companyId) => {
  const { data: response } = await getLiveboardSettingRef(companyId)

  const settings = response?.data ?? []

  return (
    settings.find((item) => item.company?.id === companyId)?.value ??
    settings.find((item) => item.company === null)?.value ??
    prodConfig
  )
}

export const getDisplayValue = (item: any, filterKey: string) => {
  if (filterKey === INSPECTION_TYPE_KEY) {
    const parsedValue = toJSON(item.value)

    return parsedValue.name || item.value || ''
  }
  return item.value || ''
}
